import { ContentNugget, lottieAnimations } from '@backrs_ui/common-ui';

import { NuggetCardList } from '@backrs_ui/grow-ui/src/components/NuggetCards/NuggetCardList';

import { Box, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

type NuggetSectionProps = Readonly<{
  nuggets: ContentNugget[];
  onNuggetClick: (nugget: ContentNugget) => void;
  loading?: boolean;
}>;

export const NuggetSection = ({ nuggets, onNuggetClick, loading = false }: NuggetSectionProps) => {
  return (
    <>
      {loading && (
        <Box sx={loadingContainerSx}>
          <Lottie animationData={lottieAnimations.dotsDotting} loop />
        </Box>
      )}

      {!loading && (
        <NuggetCardList nuggets={nuggets} onClick={onNuggetClick} direction="scrollingRow" />
      )}
    </>
  );
};

const loadingContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '200px',
  width: '100px',
  margin: '0 auto',
};
